import { useCallback, useEffect, useState } from "react";
import { fetchScheduledMaintenances } from "../containers/FieldApp/fieldAppApi";

export function countOverdueMaintenances(data) {
  const keys = new Set();
  (data.results || []).forEach((row) => {
    if (row.isOverdue) {
      keys.add(`s:${row.id}`);
    }
  });
  (data.fieldRecords || []).forEach((row) => {
    if (!row.isOverdue) {
      return;
    }
    if (row.scheduledMaintenanceId) {
      keys.add(`s:${row.scheduledMaintenanceId}`);
    } else {
      keys.add(`f:${row.uuid}`);
    }
  });
  return keys.size;
}

export function useMaintenanceOverdueCount(farmId) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!farmId) {
      setCount(0);
      return;
    }
    try {
      const data = await fetchScheduledMaintenances(farmId, {}, {});
      setCount(countOverdueMaintenances(data));
    } catch {
      setCount(0);
    }
  }, [farmId]);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 15000);
    return () => clearInterval(interval);
  }, [refresh]);

  return { count, refresh };
}
